import { Injectable } from "@nestjs/common";
import { OntDownCause, OntRealTimeData, OntState } from "@ip6m/types";
import { DDMService } from "./ddm.service";
import { EthernetStatusService } from "./ethernet-status.service";

@Injectable()
export class DataCollectorService {

    constructor(
        private ddmS: DDMService,
        private ethSS: EthernetStatusService) {}

    async realtime(ontSn: string): Promise<OntRealTimeData> {
        const ethStatus = await this.ethSS.getOntEthState(ontSn);
        return { 
            ethStatus: ethStatus,
            signal:  await this.ddmS.getData(ontSn),
            status: OntState.Online,
            downCause: OntDownCause.lossOfPower
        }
    }
}
